const FEATURES = [
    {
        name: 'postalAddress',
        description: 'Enable changing of postal address',
        hasEntitlement: true,
        entitlementName: 'PostalAddress',
        entitlementValueCheck: 'update',
        value: true,
    },
    {
        name: 'phoneNumber',
        description: 'Enable changing of phone number',
        hasEntitlement: true,
        entitlementName: 'PhoneNumber',
        entitlementValueCheck: 'update',
        value: true,
    },
    {
        name: 'bankAccount',
        description: 'Enable changing of bank account',
        hasEntitlement: true,
        entitlementName: 'BankAccount',
        entitlementValueCheck: 'update',
        value: true,
    },
    {
        name: 'emailAddress',
        description: 'Enable changing of email address',
        hasEntitlement: true,
        entitlementName: 'EmailAddress',
        entitlementValueCheck: 'update',
        value: true,
    },
    {
        name: 'familyMember',
        description: 'Enable add or remove of a family member',
        hasEntitlement: true,
        entitlementName: 'FamilyMember',
        entitlementValueCheck: 'update',
        value: true,
    },
    {
        name: 'lifeEvent',
        description: 'Enable update family member after life event',
        hasEntitlement: true,
        entitlementName: 'Life-Events',
        entitlementValueCheck: 'true',
        value: false,
    },
    {
        name: 'lifeEventHold',
        description: 'Enable update family member after life event',
        hasEntitlement: true,
        entitlementName: 'Life-Events',
        entitlementValueCheck: 'hold',
        value: false,
    },
    {
        name: 'COB',
        description: 'Enable update of coordination of benefits',
        hasEntitlement: true,
        entitlementName: 'COB',
        entitlementValueCheck: 'update',
        value: false,
    },
    {
        name: 'studentStatus',
        description: 'Enable extend or remove the student status',
        hasEntitlement: true,
        entitlementName: 'StudentStatus',
        entitlementValueCheck: 'update',
        value: true,
    },
    {
        name: 'co-branding',
        description: 'Displays or hide co-branding to a member.',
        value: false,
    },
];

export default FEATURES;
